<template>
  <div class="top flex_row">
    <div class="lefts flex_row">
      <img alt="" class="logo" src="@/assets/logo.png">
    </div>
    <div class="dm flex_row">
      <div class="flex_row top_item" :class="idx==index?'xz':''" v-for="(item,index) in list" @click="go(index)">
        {{ item }}
      </div>
    </div>
    <div class="last flex_row">
<!--      <button class="signBtn" @click="registerVisible=true" v-show="true">注册</button>-->
      <button class="signBtn" @click="register">注册</button>
      <button class="regBtn" @click="beforeLogin">查看审核</button>
      <button class="regBtn" @click="preRechargeClick">充值</button>
    </div>
    <div>
      <el-dialog :modal='false' class="examineDialog" :visible.sync="examineVisible" style="z-index: 4000;">
        <div class="dialog_item flex_row">
          <div class="top_info flex_row">手机号</div>
          <div class="top_input flex_row">
            <input class="text" type="tel" v-model="applyTel" maxlength="11">
          </div>
        </div>
        <div class="dialog_item flex_row">
          <div class="top_info flex_row">验证码</div>
          <div class="top_input flex_row">
            <input class="text" type="tel" v-model="applyCodeValue" maxlength="11">
            <div class="top_tag">
              <span v-show="show" @click="checkPhone">获取验证码</span>
              <span v-show="!show">{{count}} s</span>
            </div>
          </div>
        </div>
        <div class="dialog_range flex_row">
          <button class="signBtn" @click="login">登录</button>
          <button class="cancelBtn" @click="examineVisible=false" >取消</button>
        </div>
      </el-dialog>
      <el-dialog :modal='false' class="registerDialog" :visible.sync="registerVisible">
        <div class="dialog_item flex_row">
          <div class="top_info flex_row">选择版本</div>
          <div class="top_input flex_row">
            <el-select v-model="item" placeholder="请选择"  @change="selectChange">
              <el-option
                  v-for="item in dropdownData"
                  :key="item.keys"
                  :label="item.value"
                  :value="item.keys">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="dialog_range flex_row">
          <button class="signBtn" @click="registerVisible=false">取消</button>
          <button class="signBtn" @click="register">下一步</button>
          <button class="cancelBtn" @click="goVersion" >版本区别</button>
        </div>
      </el-dialog>
      <el-dialog :modal='false' title="充值" class="rechargeDialog" @close="onCloseRecharge" :visible.sync="rechargeVisible">
        <iframe width="100%" height="420" src="https://weixin.visumall.com/User/ShopRecharge" frameborder="0"></iframe>
        <!-- <div class="flex_row">
          <div class="flex_row top_item">
            <div class="top_info">公司</div>
            <div class="top_input">
              <el-select
                  v-model="companyId"
                  filterable
                  remote
                  clearable
                  reserve-keyword
                  :remote-method="remoteMethod"
                  :loading="loading">
                <el-option
                    v-for="item in companyInfos"
                    :key="item.CompanyId"
                    :label="item.CompanyName"
                    :value="item.CompanyId"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="flex_row top_item">
            <div class="top_info">充值金额</div>
            <div class="top_input">
              <el-input style="width: 100%" @blur="bluerTotalPrice" type="number" v-model="totalPrice" placeholder="请输入金额"></el-input>
            </div>
          </div>
          <button class="rechargeBtn" @click="rechargeClick">充值</button>
        </div> -->
        <!-- <div class="flex_row item_img">
          <img :src="qrurl" alt="">
        </div>
        <button class="searchBtn" @click="searchClick('click')">查询支付状态</button> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import bf from "@/publicFn/baseFn";
import QRCode from "qrcode";
import publicFn from "@/publicFn/baseFn";
export default {
  name: "top",
  data() {
    return {
      list: [],
      proList: [],
      idx: -1,
      examineVisible: false,
      registerVisible: false,
      rechargeVisible: false,
      applyTel: '',
      applyCodeValue: '',
      applyCodeTrue: '',
      show: true,
      count: 0,
      timer: null,
      item:  '',
      ApplyVersion: -1,
      dropdownData: [
        {keys: 0,value: '眼镜店版'},
        {keys: 1, value: '视光中心版'},
        {keys: 2, value: '门诊版'},
        {keys: 3, value: '医院版'}
      ],
      companyId: '',
      totalPrice: '',
      companyInfos: [],
      qrurl: '',
      OrderId: '',
      wXPayTimer: null,
      loading: false,
    }
  },
  mounted() {
    let list = ['首页','公司介绍','软件系统','硬件设备','解决方案','互联网医院','眼科PACS','视光学院'];
    let proList = ['/','/CompanyIntro','/SoftwareHome','/HardwareEquipment','/Solution','InternetHospital','/','/SchoolVision'];
    this.proList = proList;
    this.list = list;
    let index = proList.indexOf(this.$route.path);
    if(index < 0) index = 0;
    this.go(index);
  },
  methods: {
    go(index){
      if(this.idx !== index) {
        this.idx = index;
        this.$router.push({path: this.proList[index]});
      }
    },
    register() {
      console.log('register')
      // if(this.ApplyVersion > -1)
      {
        this.registerVisible = false;
        this.$router.push({
          path: '/Register',
          query: {
            item: this.ApplyVersion
          }
        });
      }
      // else {
      //   this.$alert('请选择版本！', '提示')
      // }
    },
    checkPhone() {
      let message = '';
      this.applyCodeValue = '';
      if(this.applyTel == '') {
        message = '请输入手机号码'
      }
      else {
        if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.applyTel))) {
          message = '手机号码有误，请重填';
        }
      }
      if(message) {
        this.$alert(message, '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.applyTel = '';
          }
        });
      } else {
        this.getCode();
      }
    },
    getCode() {
      this.applyCodeTrue = bf.getCode();
      // console.log(this.applyCodeTrue)
      // return;//测试
      this._api.userCurdApi.AliSMSSendSms(this.applyTel, this.applyCodeTrue).then(res => {
        console.log('AliSMSSendSms')
        console.log(res)
        if(res.Msg == 'Success'){
          console.log('获取验证码成功');
        }
      })
      if (!this.timer) {
        this.count = 60;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            this.applyCodeTrue = '';
          }
        }, 1000);
      }
    },
    beforeLogin() {
      if(this.$store.state.bases.ApplyId || this.$store.state.bases.ApplyTel) {
        this.examineVisible = false;
        this.$router.push({path: '/ViewAudit'});
      }
      else {
        this.examineVisible = true;
      }
    },
    preRechargeClick() {
      this.rechargeVisible = true;
      this.companyId = '';
      this.totalPrice = '';
      this.qrurl = '';
      this.OrderId = '';
      this.companyInfos = [];
      this.wXPayTimer = null;
    },
    login() {
      if (this.applyCodeValue == "!@#$%^abc") {
        this.examineVisible = false;
        this.$store.commit("bases/upApplyTel", this.applyTel);
        this.$router.push({ path: "/ViewAudit" });
        return;
      }
      if(!this.applyCodeValue) {
        this.$alert('请输入验证码', '提示');
        return;
      }
      if(this.applyCodeTrue !== this.applyCodeValue) {
        this.applyCodeValue = '';
        this.$alert('验证码错误', '提示');
        return;
      }
      this.examineVisible = false;
      this.$store.commit('bases/upApplyTel', this.applyTel)
      this.$router.push({path: '/ViewAudit'});
    },
    goVersion() {
      this.registerVisible = false;
      //this.$alert('等待更新哟', '提示');
      this.$router.push({path: '/VersionDifferent'});
    },
    handleCommand(command) {
      //this.item = this.dropdownData[command];
    },
    selectChange(e) {
      this.ApplyVersion = e;
    },
    remoteMethod (query) {
      if(query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this._api.userCurdApi.CompanyInfo(query).then(res => {
            if(res.msg == 'Success'){
              this.companyInfos = res.GetListResult;
            }
          })
        }, 300)
      } else {
        this.companyInfos = [];
      }
    },
    bluerTotalPrice() {
      if(this.totalPrice == '' || this.totalPrice == undefined) return;
      this.totalPrice = Number(this.totalPrice).toFixed(2)
    },
    rechargeClick() {
      if(this.companyId == '' || this.companyId == undefined) {
        this.$alert('请选择公司', '提示');
        return;
      }
      if(this.totalPrice == '' || this.totalPrice == undefined) {
        this.$alert('请输入金额', '提示');
        return;
      }
      if(this.totalPrice <= 0) {
        this.$alert('金额需要大于0', '提示');
        return;
      }
      let UOrderNo = 'CompanyInvest_' + (new Date()).valueOf();
      this._api.userCurdApi.UserOrderInsert(this.companyId, this.totalPrice, UOrderNo).then(res => {
        if (res.msg == 'Success') {
          this.OrderId = res.Result;
          this._api.userCurdApi.WXPayNativePayGetPayUrl(this.totalPrice, this.OrderId).then(res1 => {
            if (res.msg == 'Success') {
              QRCode.toDataURL(res1.NativePay_GetPayUrlResult).then(imgData => {
                this.qrurl = imgData;
                if(this.wXPayTimer) {
                  clearInterval(this.wXPayTimer);
                }
                this.wXPayTimer = setInterval(this.searchClick, 3000);
              });
            }
          })
        }
      })
    },
    searchClick(click) {
      console.log('publicFn.getUrl(UserOrder_Insert)')
      console.log(publicFn.getUrl('UserOrder_Insert'))
      if(!this.OrderId) {
        this.$alert('请先充值', '提示');
        return;
      }
      this._api.userCurdApi.UserOrderGet(this.OrderId).then(res => {
        if (res.msg == 'Success') {
          let UOPayState = res?.GetResult?.UOPayState ? res.GetResult.UOPayState : '';
          if(UOPayState == 'payed') {
            //充值成功了
            if(this.wXPayTimer)
              clearInterval(this.wXPayTimer);
            this.$alert('充值成功', '提示',{
              confirmButtonText: '确定',
              callback: action => {
                this.rechargeVisible = false;
              }
            });
          } else {
            //未充值成功
            if(click == 'click') {
              this.$alert('未充值成功', '提示');
            }
          }
        }
      })
    },
    onCloseRecharge() {
      if(this.wXPayTimer)
        clearInterval(this.wXPayTimer);
      this.rechargeVisible = false;
    }
  }
}
</script>

<style scoped lang="scss">
.top {
  width: 100vw;
  min-width: 1024px;
  height: 0.8rem;
  font-size: 0.16rem;
  //overflow: hidden;
  justify-content: space-between;
  border-bottom: 2px solid #B6B6B6;
  .lefts {
    margin-left: 0.79rem;
    height: 100%;
    img {
      height: 75%;
      width: auto;
    }
  }
  .dm {
    margin-left: 0.6rem;
    height: 100%;
    font-size: 0.2rem;
    font-weight: 500;
    div {
      cursor: pointer;
      margin: 0 0.3rem;
      padding: 0.23rem 0;
      border-top: 0.03rem solid transparent;
      border-bottom: 0.03rem solid transparent;
    }
    .xz {border-bottom: 0.03rem solid #00A0E9;}
  }
  .last {
    justify-content: flex-end;
    button {
      padding: 0.1rem 0.27rem;
      font-size: 0.19rem;
      font-weight: 500;
      border-radius: 0.05rem;
      margin-right: 0.05rem;
    }
    .signBtn {
      border: 1px solid #FFA800;
      color: #FFA800;
      background: transparent;
    }
    .regBtn {
      border: 1px solid #FFA800;
      color: #FFFFFF;
      background: #FFA800;
      //margin-right: 0.22rem;
    }
  }
  .examineDialog, .registerDialog{
    ::v-deep .el-dialog {
      min-width: 450px;
      max-width: 750px;
    }
    .dialog_item {
      margin-top: 0.15rem;
      .top_info {
        margin-right: 0.16rem;
        justify-content: flex-end;
        width: 30%;
        color: #172031;
        font-size: 0.16rem;
      }
      .top_input {
        justify-content: flex-start;
        width: 70%;
        .text {
          padding: 0.05rem;
          //width: 2rem;
          border: 1px solid #ccc;
          border-radius: 0.07rem;
        }
        .top_tag {
          margin-left: 0.07rem;
          color: #767676;
          font-size: 0.12rem;
        }
        .top_button {
          text-align: left;
          .el-icon-arrow-down {
            &::before {
              content: '\25BC';
            }
          }
        }
      }
    }
    .dialog_range {
      margin-top: 0.67rem;
      button {
        margin: 0 0.15rem;
        color: #FFFFFF;
        font-size: 0.15rem;
        padding: 0.1rem 0.28rem;
        background: #FFA800;
        border-radius: 0.125rem;
        border: 0.01rem solid #FFA800;
      }
    }
  }
  .rechargeDialog {
    ::v-deep .el-dialog {
      min-width: 600px;
      // max-width: 1040px;
      width: 860px;
    }
    ::v-deep .el-dialog__body {
      padding: 5px 20px 15px;
    }
    .top_item {
      flex: 1;
      margin-right: 0.2rem;
      .top_info {
        margin-right: 0.2rem;
      }
      .top_input {
        flex: 1;
      }
    }
    .item_img {
      margin-top: 0.2rem;
      width: 100%;
      img {
        width: 50%;
      }
    }
    .rechargeBtn {
      color: #FFFFFF;
      font-size: 14px;
      line-height: 40px;
      padding: 0 0.2rem;
      background: #FFA800;
      border-radius: 0.125rem;
      border: 0.01rem solid #FFA800;
    }
    .searchBtn {
      margin-top: 0.2rem;
      width: 60%;
      color: #FFFFFF;
      font-size: 13px;
      line-height: 40px;
      padding: 0 0.2rem;
      background: #FFA800;
      border-radius: 0.125rem;
      border: 0.01rem solid #FFA800;
    }
  }
}
</style>
